export default __webpack_public_path__ + "static/media/pin.ffd854ee.svg";